import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { PresentationType } from '@/@types/graphql-types';
import WatchNowButton from '@/components/buttons/WatchNowButton.vue';
import ProviderIconSquare from '@/features/ui/components/ProviderIconSquare.vue';
import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';

export default /*#__PURE__*/_defineComponent({
  __name: 'CinematicRentalCard',
  props: {
    title: null,
    additionalContexts: null,
    offer: null
  },
  setup(__props: any) {

const props = __props as {
	title: TitleDetail;
	additionalContexts: SnowplowContext[];
	offer: TitleOfferFragment;
};



const presentationTag = computed(() => {
	switch (props.offer?.presentationType) {
		case PresentationType['4K']:
			return '4K';
		case PresentationType.Hd:
			return 'HD';
		case PresentationType.Sd:
			return 'SD';
		default:
			return '';
	}
});

useProvideClickoutPlacement('cinematic_buybox');

return { __sfc: true,props, presentationTag, FontAwesomeIcon, faPlay, WatchNowButton, ProviderIconSquare }
}

})